<template>
  <ToggleSection label="Sample Preparation" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[
        ['is_cryo_tem', 'is_array_tomography', 'freeze_substitution'],
        ['is_vitrification_cryo_tem', 'is_fibmilling_cryo_tem', null],
        ['preparation_method'],
        ['filler', 'resin'],
      ]"
      :dv="dv"
      :disabled-fields="disabledFields"
    />
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'EMSamplePreparation',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    hiddenFields: { type: Array, default: () => [] },
  },
  setup(props) {
    const isCryoDisabled = computed(() =>
      props.hiddenFields?.includes('cryo_dependent_controls'),
    )

    const disabledFields = computed(() => ({
      is_vitrification_cryo_tem: isCryoDisabled.value,
      is_fibmilling_cryo_tem: isCryoDisabled.value,
    }))

    return { disabledFields }
  },
}
</script>
